import React, { useState } from 'react';
import classnames from 'classnames';
import border from 'scy/border.mod.scss';
import padding from 'scy/padding.mod.scss';
import margin from 'scy/margin.mod.scss';
import { flex, flex1 } from 'scy/flex.mod.scss';
import { H5, SecondaryH5 } from 'scy/text';
import {
  uppercase,
  fontSizeXXS,
  fontSizeS,
  accent,
  secondary,
  sansSerifLight,
  sansSerifMedium,
  letterSpacingL
} from 'scy/text/styles.mod.scss';
import PaymentLogo from 'scy/PaymentLogo';
import ReceiptModal from './ReceiptModal';
import ProductRow from './ProductRow';
import { TextButton } from 'scy/buttons';
import Receipt from 'images/icons/receipt.svg?react-svg';
import {
  halfOpacity,
  translucent,
  textRight,
  valignMiddle
} from 'scy/utils.mod.scss';
import styles from './styles.mod.scss';

function AddressText({ children }) {
  return (
    <div
      className={classnames(
        fontSizeS,
        sansSerifMedium,
        letterSpacingL,
        accent,
        uppercase
      )}
    >
      {children}
    </div>
  );
}

export default function OrderSummary({
  order,
  shippingName = '',
  shippingEstimate = ''
}) {
  const [showReceipt, setShowReceipt] = useState(false);
  const { address, unit } = order.delivery_address_detail;
  const delivery_notes = order.delivery_notes;

  return (
    <div className={styles.orderSummary}>
      <div className={classnames(border.topAlt, padding.sm)}>
        <SecondaryH5 uppercase className={halfOpacity}>
          Delivery To
        </SecondaryH5>
        {order.gift_info && order.gift_info.recipient && (
          <AddressText>{order.gift_info.recipient}</AddressText>
        )}
        <AddressText>{`${address}${unit ? `, ${unit}` : ''}`}</AddressText>
        {!!delivery_notes && (
          <div
            className={classnames(
              fontSizeXXS,
              sansSerifLight,
              secondary,
              translucent,
              margin.top_xs
            )}
          >
            {delivery_notes}
          </div>
        )}
      </div>

      <div
        className={classnames(
          border.topAlt,
          border.bottomAlt,
          padding.left_sm,
          padding.right_sm
        )}
      >
        <div
          className={classnames(
            flex,
            accent,
            padding.top_sm,
            padding.bottom_sm
          )}
        >
          <SecondaryH5 uppercase className={classnames(flex1, halfOpacity)}>
            Order Summary
          </SecondaryH5>
          <TextButton
            className={classnames(padding.left_xs, padding.right_xs)}
            onClick={() => setShowReceipt(true)}
          >
            <Receipt className={valignMiddle} />
          </TextButton>
        </div>
        {(order.products || []).map(product => (
          <ProductRow
            key={product.sku_id}
            product={product}
            quantity={order.skus[product.sku_id]}
            className={border.bottomAlt}
          />
        ))}

        {!!shippingName && (
          <div>
            <SecondaryH5
              uppercase
              className={halfOpacity}
              marginClass={classnames(margin.top_sm, margin.bottom_xs)}
            >
              Shipping
            </SecondaryH5>
            <div className={classnames(flex, margin.xs, border.bottomAlt)}>
              <H5
                uppercase
                tag="div"
                className={flex1}
                marginClass={classnames(margin.top_0, margin.bottom_sm)}
              >
                {shippingName}
              </H5>
              {!!shippingEstimate && (
                <SecondaryH5 uppercase>({shippingEstimate})</SecondaryH5>
              )}
            </div>
          </div>
        )}

        <div
          className={classnames(
            flex,
            padding.top_sm,
            padding.bottom_sm,
            padding.left_xs,
            padding.right_xs
          )}
        >
          {order.card && order.card.brand && (
            <div className={margin.right_sm}>
              <PaymentLogo brand={order.card.brand} />
            </div>
          )}
          {order.card && order.card.last4 && (
            <H5 uppercase tag="div">
              {order.card.last4}
            </H5>
          )}
          <H5 uppercase tag="div" className={classnames(flex1, textRight)}>
            ${order.total}
          </H5>
        </div>
      </div>

      <ReceiptModal
        isOpen={showReceipt}
        handleClose={() => setShowReceipt(false)}
        order={order}
      />
    </div>
  );
}
